import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import type ModalManager from "cc-frontend/services/modal-manager"
import styles from "./edit-modal.module.css"

export default class EditModal extends Component {
  readonly styles = styles

  @service modalManager!: ModalManager

  @tracked isSmall = false
  @action setSmallWidth() {
    this.isSmall = true
  }
  @action setNormalWidth() {
    this.isSmall = false
  }
}
